module.exports = __webpack_public_path__ + "static/media/icon-moon.c299f678.svg";